import { Link } from "react-router-dom";
import { CallButton } from "@/components/site/Cta";
import { usePageSeo } from "@/lib/seo";

export default function NotFound() {
  usePageSeo("/404");
  return (
    <section className="mx-auto max-w-3xl px-5 py-32 text-center" data-testid="not-found">
      <p className="eyebrow">404</p>
      <h1 className="mt-3 text-5xl font-extrabold uppercase text-white">Page not found</h1>
      <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
        <CallButton id="notfound-call" />
        <Link to="/" className="btn-ghost" data-testid="notfound-home">Back to home</Link>
      </div>
    </section>
  );
}
